export default "__VITE_ASSET__CkMstn7d__"